// import { logErrorWithTracking } from "../modal/logging/logger";

export default class CustomError extends Error {
  constructor(message) {
    super(message);
    this.name = "CustomError";
    // logErrorWithTracking(this.name, message)
  }
}
